import styled from '@emotion/styled';
import { getSpace } from '../../../../utils/index.ts';
import { Text } from '../../../Text/index.ts';

export const Title = styled(Text)`
  display: block;
  padding-left: ${getSpace('14')};
`;
